// Minimal p-limit-style concurrency limiter (no external dependency).
//
// Opening a dashboard mounts every widget at once and each widget fetches its
// own indicator data. Without a cap that produces ~40 simultaneous requests,
// which saturates the browser's per-host connection pool and the backend. All
// indicator/data fetches funnel through a shared limiter so at most
// `concurrency` requests are in flight at any time; the rest queue and drain as
// slots free up.

const createLimiter = concurrency => {
	let active = 0;
	const queue = [];

	const next = () => {
		if (active >= concurrency || queue.length === 0) {
			return;
		}
		active++;
		const { fn, resolve, reject } = queue.shift();
		Promise.resolve()
			.then(fn)
			.then(resolve, reject)
			.then(() => {
				active--;
				next();
			});
	};

	const limit = fn =>
		new Promise((resolve, reject) => {
			queue.push({ fn, resolve, reject });
			next();
		});

	limit.activeCount = () => active;
	limit.pendingCount = () => queue.length;
	return limit;
};

// 6 matches the HTTP/1.1 per-host connection cap; tune 4-8 if needed.
export const indicatorRequestLimiter = createLimiter(6);

export default createLimiter;
